/* /video — the explainer on its own page, for sharing. ?lang=en|ar opens it in that language. Public, no Shell. */
import { useEffect, useRef } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { useI18n } from "../../i18n";
import { Icon } from "../../ui";
import { AuthTop } from "./components/AuthLayout";
import { ExplainerVideo } from "./components/ExplainerVideo";
import "./home-extra.css";
import { useSeo } from "../../seo/useSeo";
import { onStaticPage } from "../../seo/paths";

export default function Video() {
  const i = useI18n();
  const { L } = i;
  const [params, setParams] = useSearchParams();
  const applied = useRef(false);
  const pending = useRef<string | null>(null);

  // a shared link opens in the language it was shared in (once; the toggle still works afterwards)
  useEffect(() => {
    if (applied.current) return;
    applied.current = true;
    if (onStaticPage()) return; // /video/ and /ar/video/ carry the language in the path
    const want = params.get("lang");
    if ((want === "en" || want === "ar") && want !== i.lang) { pending.current = want; i.toggleLang(); }
  }, [params, i]);
  // keep the address bar shareable as the visitor switches language
  useEffect(() => {
    if (onStaticPage()) return;
    if (pending.current) { if (pending.current === i.lang) pending.current = null; return; }
    if (params.get("lang") !== i.lang) setParams({ lang: i.lang }, { replace: true });
  }, [i.lang, params, setParams]);

  useSeo("/video");

  return (
    <div className="xv-page" data-testid="video-page">
      <AuthTop both />
      <div className="sec-h center xv-page-h">
        <span className="eyebrow">{L("See it in 90 seconds", "شاهده في 90 ثانية")}</span>
        <h1>{L("Meet Sara: from piles of paper to payroll in one click", "تعرّف على سارة: من أكوام الأوراق إلى الرواتب بضغطة واحدة")}</h1>
        <p className="muted">{L("StartHR is the HR and payroll system for Saudi businesses — GOSI, WPS, Iqamas and attendance in Arabic and English.", "ستارت HR نظام الموارد البشرية والرواتب للمنشآت السعودية — التأمينات وحماية الأجور والإقامات والحضور بالعربية والإنجليزية.")}</p>
      </div>
      <ExplainerVideo />
      <div className="row xv-page-cta">
        <Link className="btn gold lg" to="/setup" data-testid="video-trial"><span>{L("Start your 30-day free trial", "ابدأ تجربة 30 يومًا مجانًا")}</span><Icon name="chevron-right" className="s" /></Link>
        <Link className="btn lg" to="/home" data-testid="video-more"><span>{L("Learn more about StartHR", "اعرف المزيد عن ستارت HR")}</span></Link>
      </div>
    </div>
  );
}
